const $ = require("jquery");

const SimpleTabs = {

  init() {
    const $items = $('.js-simple-tabs');
    if ( $items.length > 0 ) {
      this.setup();
    }
  },
  setup() {
    const $clickableTabs = $('.js-simple-tabs.js-change-clicked-tab');
    var $mouseEvent = 'mouseover';
    if ( $clickableTabs.length > 0 ) {
      $mouseEvent = 'click';
    }

    $('.c-simple-tabs .js-tab-item a').on($mouseEvent, function(event){
      var tab_id = $(this).attr('href');
      event.stopPropagation(); // Disable event propagation
      $('.c-simple-tabs .js-tab-item').removeClass('c-simple-tabs--active');
      $('.c-simple-tabs__panel').removeClass('c-simple-tabs--active');
      $(this).closest('.c-simple-tabs__link').addClass('c-simple-tabs--active');
      $(tab_id).addClass('c-simple-tabs--active');
      return false;
    });

    
    $('.c-simple-tabs .js-tab-item a').on('click', function(event){
      event.stopPropagation(); // Disable event propagation
      return false;
    });

    $('.c-simple-tabs .c-simple-tabs__panel-title').on('click', function(event){
      var tab_id = $(this).find('a').attr('href');
      
      event.stopPropagation(); // Disable event propagation
      $('.c-simple-tabs .js-tab-item').removeClass('c-simple-tabs--active');
      $('.c-simple-tabs__panel').removeClass('c-simple-tabs--active');
      $(this).closest('.c-simple-tabs').find('.js-tab-item a[href*="'+tab_id+'"]').parent().addClass('c-simple-tabs--active');
      $(tab_id).addClass('c-simple-tabs--active');
      
      $('html, body').animate({
        scrollTop: $(tab_id).offset().top - 100
      }, 500); // 1000 milliseconds for the animation

      return false;
    });
  }
};
$(SimpleTabs.init.bind(SimpleTabs));
